// extracted by mini-css-extract-plugin
export default {"courseCardsList":"CourseCardsList_courseCardsList__Dvr2o","courseCard":"CourseCardsList_courseCard__bK1pu"};